import { Reveal } from "./Reveal";

export const PictureThis = () => (
  <section data-testid="picture-this-section" className="py-16 sm:py-24 lg:py-32 bg-[#F4EFE6]">
    <div className="max-w-6xl mx-auto px-4 sm:px-8 lg:px-16 grid grid-cols-1 md:grid-cols-12 gap-10 lg:gap-16 items-center">
      <div className="md:col-span-7">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#8C4A32] mb-4">Picture this</p>
          <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl leading-[1.15] text-[#241E1A] font-medium">
            What abundance sounds like at three and a half.
          </h2>
          <div className="mt-6 space-y-5 text-base sm:text-lg leading-relaxed text-[#5C524A]">
            <p>
              We're in the bakery aisle. My daughter Helena spots the cake, and instead of a
              meltdown or a plea, she lights up:
            </p>
            <blockquote className="border-l-2 border-[#8C4A32] pl-6 py-2 font-serif-display italic text-2xl sm:text-3xl text-[#241E1A] leading-snug">
              "Mommy, we should get this for our birthday!"
            </blockquote>
            <p>
              She isn't asking for more for herself. She's thinking about celebrating us. We leave
              the store holding hands, both of us full of joy. I didn't buy everything. I didn't
              have to say no fifteen times.
            </p>
            <p className="font-medium text-[#241E1A]">That's not a behavior trick. That's what abundance sounds like at 3.5.</p>
            <p>
              Now picture your daughter at 30: asking for what she wants without flinching,
              receiving without guilt, and knowing there's enough. She learned it from you —
              every day, in moments just like this.
            </p>
          </div>
        </Reveal>
      </div>
      <div className="md:col-span-5">
        <Reveal delay={0.15}>
          <div className="rounded-2xl overflow-hidden border border-[#EFE6D8] bg-[#241E1A] shadow-[0_24px_60px_-24px_rgba(36,30,26,0.4)]">
            <div className="aspect-[9/16] max-h-[560px] w-full">
              <iframe
                data-testid="helena-video-embed"
                src="https://www.youtube-nocookie.com/embed/N3HitVzBl9c?rel=0"
                title="Helena in the bakery aisle"
                className="w-full h-full"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                loading="lazy"
              />
            </div>
          </div>
          <p className="mt-3 text-xs uppercase tracking-[0.2em] text-[#8A7E74] text-center">Watch: the bakery aisle, with Helena</p>
        </Reveal>
      </div>
    </div>
  </section>
);
